import { Component, OnInit } from '@angular/core';
import { BehavioursubjectService } from 'src/app/shared/helper/service/behavioursubject.service';

@Component({
  selector: 'app-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.scss']
})
export class PrivacypolicyComponent implements OnInit {
  breadcrumb = [
    {
      name: 'Privacy Policy',
      url: '/privacypolicy',
    },
  ];
  constructor(private behaviourSubjectService:BehavioursubjectService) { }

  ngOnInit(): void {
    this.behaviourSubjectService.changeBreadCrumbData(this.breadcrumb);

  }
}
